import axiosClient from './axiosClient';

export const authAPI = {
  login: (email, password) => {
    return axiosClient.post('/auth/login', { email, password });
  },

  verifyOtp: (email, otp, newPassword) => {
    return axiosClient.post('/auth/verify-otp', { email, otp, newPassword });
  },

  forgotPassword: (email) => {
    return axiosClient.post('/auth/forgot-password', { email });
  },

  resetPassword: (email, otp, newPassword) => {
    return axiosClient.post('/auth/reset-password', { email, otp, newPassword });
  },

  logout: () => {
    return axiosClient.post('/auth/logout');
  },
};